module.exports = __webpack_public_path__ + "static/media/play.8d4e8810.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/ugcvisualization/assets/play.svg
// module id = 1069
// module chunks = 0